/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/
import { useEffect, useState } from 'react';

interface WindowSize {
  width: number;
  height: number;
  isMobile: boolean;
}
export const mobileBreakpoint = 800;

export function useWithWindowSize(): WindowSize {
  const initialWindowWidth =
    typeof window !== 'undefined' ? window.innerWidth : 0;
  const initialWindowHeight =
    typeof window !== 'undefined' ? window.innerHeight : 0;
  const [windowSize, setWindowSize] = useState({
    width: initialWindowWidth,
    height: initialWindowHeight,
  });
  const isMobile = windowSize.width > 0 && windowSize.width <= mobileBreakpoint;

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    width: windowSize.width,
    height: windowSize.height,
    isMobile,
  };
}
